import script from "./SubjectNextPageGrade.vue?vue&type=script&setup=true&lang=js"
export * from "./SubjectNextPageGrade.vue?vue&type=script&setup=true&lang=js"

import "./SubjectNextPageGrade.vue?vue&type=style&index=0&id=2df391c5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2df391c5"]])

export default __exports__